import { _ as t } from "./index980.mjs";
var r = t;
function p(a) {
  return r(this, a).has(a);
}
var e = p;
export {
  e as _
};
